export default "/fonts/vendor/primeicons/primeicons.woff2?78172950b335ccdb94e23e39fe3eafc1";